import { NgModule } from '@angular/core';

import { InitialsPipe } from './initials';
import { LocalizedDatePipe } from './localized-date';
import { ObjectsFilterPipe } from './objects-filter';
import { StringFilterPipe } from './string-filter';

const pipes = [InitialsPipe, ObjectsFilterPipe, StringFilterPipe, LocalizedDatePipe];

@NgModule({
	exports: [...pipes],
	declarations: [...pipes],
	providers: []
})
export class PipesModule {}
